import * as userSelectors from "../store/selectors/user/userSelectors";
import AccessDeniedDialog from "./common/AccessDeniedDialog";
import TemplateAdmin from "components/templates/TemplateAdmin";
import { connect } from "react-redux";
import { Route, Routes } from "react-router-dom";

// The Templates admin page is web:admin only. Gate the route itself (not just
// the menu link) so it can't be reached by URL, matching SettingsApp/AdminApp.
const TemplatesApp = ({ isAdminUser }) => {
  if (!isAdminUser) {
    return (
      <AccessDeniedDialog
        message={"Your account does not have administrator privileges."}
      />
    );
  }
  return (
    <div className={"app"}>
      <Routes>
        <Route path={"/"} element={<TemplateAdmin />} />
        <Route path={":templateId"} element={<TemplateAdmin />} />
      </Routes>
    </div>
  );
};

const mapStateToProps = (state) => ({
  isAdminUser: userSelectors.isAdminUser(state),
});

export default connect(mapStateToProps)(TemplatesApp);
